export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvTable.vue?vue&type=template&id=5c0e09fb&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvTable.vue?vue&type=template&id=5c0e09fb&lang=pug&
// module id = 147
// module chunks = 0 1